module.exports = __webpack_public_path__ + "static/img/Fr.-Sam-V.-Gabriel-Cor-Episcopos-263x300.4b59b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/Fr.-Sam-V.-Gabriel-Cor-Episcopos-263x300.jpg
// module id = W+TL
// module chunks = 0